import {getCheckoutClient} from "../config/CheckoutClient";
import {confirmationSlice} from "../slices/confirmation";

export function getConfirmationData(token, secret) {
    return (dispatch, getState) => {
        let state = getState();
        return getCheckoutClient(state.ui.apiUrl).reservationGetRequest(token, 'confirmation', secret).then((result) => {
            dispatch(confirmationSlice.actions.setConfirmationEvents({events: result.body.data.attributes.events}));
            dispatch(confirmationSlice.actions.setReceiptUrl({url: result.body.data.attributes.receiptUrl}));
        }).catch((error) => {
            return Promise.reject();
        });
    }
}
